/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Seat_PlayerInputs */



/**
* | output |
* | --- |
* | "Seat a player" |
*
* @param {Rounds_Seat_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seat_player = /** @type {((inputs?: Rounds_Seat_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seat_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Placer un joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sentar a un jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alocar um jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fai sedere un giocatore")
	return /** @type {LocalizedString} */ ("Seat a player")
});